/* eslint-disable react-hooks/exhaustive-deps */
import ptBR from "date-fns/locale/pt-BR";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Input } from "../../../../../_layout/_partials/controls";
import { DatePickerField } from "../../../../../_layout/_partials/controls/forms/DatePickerField";
import * as actions from "../../../../_redux/dashboardConsorcio/dashboardConsorcioActions";
import { getSelectUCCliente } from "../../../../lib/selectAPI";

registerLocale("ptBR", ptBR);

export function DashboardConsorcioFilter() {
  const { dashboardConsorcioFiltro, bigNumbers } = useSelector(
    state => ({
      dashboardConsorcioFiltro:
        state.dashboardConsorcio.dashboardConsorcioFiltro,
      bigNumbers: state.dashboardConsorcio.bigNumbers,
    }),
    shallowEqual
  );

  const { idCliente } = JSON.parse(localStorage.getItem("@areacliente/user"));

  const [mesReferencia, setMesReferencia] = useState(
    dashboardConsorcioFiltro
      ? new Date(moment(dashboardConsorcioFiltro.filter.mesReferencia))
      : new Date()
  );

  const [ucCombo, setUcCombo] = useState([]);

  function formatDate(date) {
    if (date) {
      return new Date(moment(date));
    } else {
      return new Date();
    }
  }

  const initialValues = {
    mesReferencia: dashboardConsorcioFiltro
      ? formatDate(dashboardConsorcioFiltro.filter.mesReferencia)
      : new Date(),
    idUC: dashboardConsorcioFiltro
      ? dashboardConsorcioFiltro.filter.idUC
      : ucCombo[0].idUC,
    cpfCnpj: dashboardConsorcioFiltro
      ? dashboardConsorcioFiltro.filter.cpfCnpj
      : "",
    nomeTitular: dashboardConsorcioFiltro
      ? dashboardConsorcioFiltro.filter.nomeTitular
      : "",
    endereco: dashboardConsorcioFiltro
      ? dashboardConsorcioFiltro.filter.endereco
      : ""
  };

  const [exibirNome, setExibirNome] = useState("");
  const [exibirEndereco, setExibirEndereco] = useState("");
  const [exibirCPFCNPJ, setExibirCPFCNPJ] = useState("");

  function formatarCnpjCpf(cnpjCpf) {
    const numeroLimpo = cnpjCpf.replace(/[^\d]/g, '');

    if (numeroLimpo.length === 14) {
      return `${numeroLimpo.slice(0, 2)}.${numeroLimpo.slice(2, 5)}.${numeroLimpo.slice(5, 8)}/${numeroLimpo.slice(8, 12)}-${numeroLimpo.slice(12)}`;
    } else if (numeroLimpo.length === 11) {
      return `${numeroLimpo.slice(0, 3)}.${numeroLimpo.slice(3, 6)}.${numeroLimpo.slice(6, 9)}-${numeroLimpo.slice(9)}`;
    } else {
      return cnpjCpf;
    }
  }

  function substituirPadrao(str) {
    const padrao = /,\s*,/g;
    if (padrao.test(str)) {
      const substituido = str.replace(padrao, ','); // Substitui ",  ," por ","
      return substituido;
    } else {
      return str;
    }
  }

  useEffect(() => {
    if (bigNumbers !== null) {
      if (bigNumbers.nomeTitular != null) {
        setExibirNome(bigNumbers.nomeTitular)
      } else {
        setExibirNome("");
      }
      if (bigNumbers.endereco !== null && bigNumbers.endereco !== ", , , , , , ") {
        var enderecoFormatado = substituirPadrao(bigNumbers.endereco)
        setExibirEndereco(enderecoFormatado)
      } else {
        setExibirEndereco("");
      }
      if (bigNumbers.cpfCnpj != null) {
        var cpfFormatado = formatarCnpjCpf(bigNumbers.cpfCnpj)
        setExibirCPFCNPJ(cpfFormatado)
      } else {
        setExibirCPFCNPJ("");
      }
    }
  }, [bigNumbers]);

  const dispatch = useDispatch();

  useEffect(() => {
    setExibirNome("");
    setExibirEndereco("");
    setExibirCPFCNPJ("");
    dispatch(actions.fetchBigNumbers(dashboardConsorcioFiltro));
    dispatch(actions.fetchBigNumbersUltimoMes(dashboardConsorcioFiltro));
    dispatch(actions.fetchGraficoCompararEconomia(dashboardConsorcioFiltro));
    dispatch(actions.fetchHistoricoEconomia(dashboardConsorcioFiltro));
    dispatch(actions.fetchHistoricoFaturas(dashboardConsorcioFiltro));
  }, [dashboardConsorcioFiltro]);

  useEffect(() => {
    getSelectUCCliente(false, idCliente).then(response => setUcCombo(response));
  }, []);

  function setFiltro(filtro) {
    setExibirNome("");
    setExibirEndereco("");
    setExibirCPFCNPJ("");
    dispatch(actions.setFiltroDashboardConsorcio(filtro));
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={({ mesReferencia, idUC, cpfCnpj, nomeTitular, endereco }) => {
          setFiltro({
            mesReferencia,
            idUC: parseInt(idUC),
            cpfCnpj,
            nomeTitular,
            endereco
          });
        }}
      >
        {({ values, handleSubmit, handleBlur, setFieldValue }) => (
          <Form className="">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-1.5 md:gap-3 ">
              <div className="">
                <DatePickerField
                  label="Mês Referência"
                  name="mesReferencia"
                  selected={mesReferencia}
                  dateFormat="MMMM/yyyy"
                  disabledKeyboardNavigation
                  showMonthYearPicker
                  showFullMonthYearPicker
                  showTwoColumnMonthYearPicker
                  locale={ptBR}
                  autoComplete="off"
                  onChange={date => {
                    setFieldValue(
                      "mesReferencia",
                      moment(date).format("YYYY-MM-01")
                    );
                    setMesReferencia(date);
                    handleSubmit();
                  }}
                />
              </div>
              <div className="mb-2">
                <label className="text-gray-500 text-sm font-semibold">
                Unidade Consumidora
                </label>
                <select
                  className="w-full h-11 pl-3 pr-6 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary"
                  name="idUC"
                  value={values.idUC}
                  onChange={e => {
                    setFieldValue("idUC", e.target.value);
                    handleSubmit();
                  }}
                >
                  <option value="">Selecione uma UC</option>
                  {ucCombo.map(item => (
                    <option value={item.idUC}>{item.uc}</option>
                  ))}
                </select>
              </div>
              <div>
                <Field
                  name="cpfCnpj"
                  component={Input}
                  label="CPF"
                  disabled
                  value={exibirCPFCNPJ && exibirCPFCNPJ === "" ? "Selecione uma U.C para visualizar" : exibirCPFCNPJ}
                  placeholder="Selecione uma U.C para visualizar"
                  className="w-full h-11 pl-3 pr-8 mt-1.5 text-sm font-medium text-gray-600 rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary placeholder:text-gray-400 disabled:bg-gray-200 disabled:text-gray-600"
                />
              </div>
              <div>
                <Field
                  name="nomeTitular"
                  component={Input}
                  disabled
                  label="Nome do titular"
                  value={exibirNome && exibirNome === "" ? "Selecione uma U.C para visualizar" : exibirNome}
                  placeholder="Selecione uma U.C para visualizar"
                  className="w-full h-11 pl-3 pr-8 mt-1.5 text-sm font-medium text-gray-600 rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary placeholder:text-gray-400 disabled:bg-gray-200 disabled:text-gray-600"
                />
              </div>
              <div className="col-span-2 md:col-span-1">
                <Field
                  name="endereco"
                  component={Input}
                  disabled
                  value={exibirEndereco && exibirEndereco === "" ? "Selecione uma U.C para visualizar" : exibirEndereco}
                  label="Endereço"
                  placeholder="Selecione uma U.C para visualizar"
                  className="w-full h-11 pl-3 pr-8 mt-1.5 text-sm font-medium text-gray-600 rounded-lg border border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary placeholder:text-gray-400 disabled:bg-gray-200 disabled:text-gray-600"
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
